import React from 'react'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'

export const Calendar = ({
	initialDate,
	events,
	onClickEvent,
	onClickDate,
	onDatesSet,
	...props
}) => {
	// dayCellClassNames 함수 추가
	const getDayCellClassNames = (arg) => {
		const dateStr = arg.date.toISOString().split('T')[0] // 'YYYY-MM-DD' 형식
		// FullCalendar 이벤트 목록에서 해당 날짜에 이벤트가 있는지 확인
		const hasEvents = events.some((event) => {
			// 이벤트 시작일과 종료일 사이에 클릭된 날짜가 있는지 확인
			// FullCalendar 이벤트의 end는 'exclusive'이므로 하루를 빼줘야 합니다.
			// 하지만 dayGridPlugin에서 allDay: true인 경우 end 날짜는 포함됩니다.
			// 따라서, end 날짜까지 포함하려면 날짜 계산 로직을 좀 더 명확히 해야 합니다.
			// 간단하게는, 이벤트의 시작일과 종료일이 해당 날짜를 포함하는지 확인합니다.
			return dateStr >= event.start.substring(0, 10) && dateStr <= event.end.substring(0, 10)
		})

		return hasEvents ? ['has-tour-event'] : [] // 대회가 있으면 'has-tour-event' 클래스 추가
	}

	return (
		<FullCalendar
			id="scheduleCalendar"
			className="fc fc-media-screen fc-direction-ltr"
			plugins={[dayGridPlugin, interactionPlugin]}
			locale="en"
			firstDay={1}
			initialDate={initialDate}
			initialView="dayGridMonth"
			headerToolbar={{
				start: 'prev',
				center: 'title',
				end: 'next',
			}}
			aspectRatio={5}
			height="auto"
			contentHeight="auto"
			events={events}
			eventClick={onClickEvent}
			editable={false}
			selectable={false}
			dayCellClassNames={getDayCellClassNames}
			datesSet={onDatesSet} // 달력 날짜 변경 시 콜백
		/>
	)
}
